(function () {
  function initDrawer() {
    var drawer = document.getElementById("rsd-drawer");
    var overlay = document.getElementById("rsd-overlay");
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add("is-open");
      overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function close() {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }

    var closeBtn = drawer.querySelector("[data-rsd-close]");
    if (closeBtn) closeBtn.addEventListener("click", close);
    overlay.addEventListener("click", close);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) close();
    });

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-open-ring-size-drawer]");
      if (trigger) {
        e.preventDefault();
        open();
      }
    });

    var addBtn = drawer.querySelector("[data-rsd-add-to-cart]");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var originalText = addBtn.textContent;
        addBtn.textContent = "ADDING...";
        addBtn.disabled = true;

        fetch("/products/the-ar-ring-sizer.js")
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var variantId = product.variants[0].id;
            return window.Cart.add([{ id: variantId, quantity: 1 }]);
          })
          .then(function () {
            addBtn.textContent = "ADDED!";
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 2000);
          })
          .catch(function (err) {
            addBtn.textContent = (err && err.description) || "ERROR";
            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 2500);
          });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDrawer);
  } else {
    initDrawer();
  }
})();
